import { SOCKET_INIT_STATE } from './actions'

const initialState = {
	socketWorks: false
}

export default (state = initialState, action) => {
	switch (action.type) {
	case SOCKET_INIT_STATE: {
		return {
			...state,
			socketWorks: action.payload
		}
	}
	default: {
		return state
	}
	}
}
